module.exports = "/static/Images/pt-br/VeryUnsatisfied.png";